





















































import { Component, Vue, Prop } from 'vue-property-decorator';
import { getHelpUrl } from '@/utils/getHost';
@Component
export default class ProgrammeDetail extends Vue {
  @Prop({}) public articleDetail: any;
  private helpUrl: any = getHelpUrl();
  private lastOrNext: any = [];
  private created() {
    this.getLastOrNext();
  }

  get processedArticleDetail() {
    return this.$tool.processArticleDetail(this.articleDetail.content);
  }
  private getLastOrNext() {
    const planType: any = this.$route.query.type === '6' ? 1 : this.$route.query.type === '7' ? 2 : 3;
    this.$apis
      .getLastOrNext({
        type: 3,
        articleType: 2,
        planType,
      })
      .then((res: any) => {
        console.log(res, '上下案例');
        this.lastOrNext = res;
      });
  }
  // 文章有帮助
  private getArticleUseful() {
    if (this.articleDetail.id !== null) {
      this.$apis.getArticleUseful({ id: this.articleDetail.id });
      this.$message({
        message: '提交成功，感谢您的建议！',
        type: 'success',
      });
    }
  }

  // 文章无帮助
  private getArticleUseless() {
    if (this.articleDetail.id !== null) {
      this.$apis.getArticleUseless({ id: this.articleDetail.id });
    }
  }
}
